import React from "react";
import ParagraphText from "../ParagraphText";
import TitleH4 from "../TitleH4";
import {
  Grid,
  Typography,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import ParagraphList from "../ParagraphList";
import { Card, CardContent, List, ListItem } from "@mui/material";

const Jobs = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={2}>
        {/* Left column (empty) */}
      </Grid>
      <Grid item xs={12} md={8}>
        <TitleH4>Join Our Team</TitleH4>
        <ParagraphText>
          We’re always excited to meet passionate, curious, and driven people
          who want to shape the built environment with purpose and creativity.
        </ParagraphText>
        <ParagraphText>
          We are currently looking for Architects, Junior Architects / Intern
          Architects and Architecture Students (final years).
        </ParagraphText>
        <ParagraphText>
          Whether you’re a seasoned professional or just starting your journey
          in architecture, we value strong design thinking, attention to detail,
          and a collaborative mindset.
        </ParagraphText>
        {/* <ParagraphText>
          If you’d like to join our team, please send us your CV and portfolio
          by clicking the Apply Now button below.
        </ParagraphText> */}
        <ParagraphText>
          We’re looking forward to seeing your work!
        </ParagraphText>
      </Grid>
    </Grid>
  );
};

export default Jobs;
